<template>
  <transition-group tag="ul" :name="transition"  class="blog__feed">
    <li v-for="post in feed" class="preview" :key="post.wikiBlogId">
      <figure class="preview__figure" :style="getBgImg(post.smallImageLocation)">
        <transition name="v--fade">
          <figcaption v-if="!reading || $device.phone" class="preview__details">
            <router-link class="preview__title"
              :to="`/blog/read/${post.wikiBlogId}`"
              @click.native="scrollTo(0, 220, scrollDelay)">
              {{ post.title }}
            </router-link>
            <div class="preview__meta">
              <time class="preview__published">
                {{ prettyDate(post.publishDate) }}
              </time>
              {{ post.author }}
            </div>
          </figcaption>
        </transition>
      </figure>
    </li>
  </transition-group>
</template>

<style>
  a:hover {
    text-decoration: none !important;
  }
</style>
<script>
import { scrollTo, kebabify, prettyDate } from '../helpers'
import axios from 'axios'

export default {
  name: 'blog-feed',
  resource: 'BlogFeed',

  props: {
    filters: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      urlOrigin: null,
      posts: [],
      transition: 'preview-appear',
    }
  },

  computed: {
    reading() { return this.filters.post },
    scrollDelay() { return (this.$device.phone) ? 0 : 560 },
    feed() {
      const filterBy = {
        post: (filter, { wikiBlogId }) => filter === wikiBlogId,
        author: (filter, { author }) => filter === this.kebabify(author)
      }

      if (!Object.keys(this.filters).length) return this.posts

      return this.posts.filter(post => {
        return Object.keys(this.filters).every(filter => {
          return filterBy[filter](this.filters[filter], post)
        })
      })
    }
  },

  methods: {
    scrollTo,
    kebabify,
    prettyDate,
    getBgImg(src) {
      return { backgroundImage: `url(${src})` }
    },
    stackPosts(posts) {
      let interval
      const stack = () => {
        this.posts.push(posts.shift())

        if (!posts.length) {
          this.transition = 'preview'
          clearInterval(interval)
        }
      }

      interval = setInterval(stack, 125)
    }
  },
  mounted() {

   this.urlOrigin = window.location.origin;
   this.$backendService.getStoreContentInfo(this.$productStoreId).then (result => {
      this.productStoreId = result.data.productStore.productStoreId;
      this.contentWikiSpaceId = result.data.contentWikiSpaceId;
      this.$backendService.getBlogInfo(this.productStoreId, this.contentWikiSpaceId).then (resultBlog => {
        this.posts = resultBlog.data.wikiBlogList;
        this.numberBlogPost = resultBlog.data.numberBlogPost;
      })
    })
 }
}
</script>



// WEBPACK FOOTER //
// src/components/BlogFeed.vue